import styled from '@emotion/styled';

import { FormActions } from '@/components/SignUp/signupStyles';

/** 회원가입 페이지와 동일한 인증(로그인·찾기) 레이아웃 */
export const AuthPage = styled.main`
	padding-top: calc(${(props) => props.theme.heights.header} + 6rem);
	padding-bottom: 10rem;
	background: ${(props) => props.theme.ui.surface.subtle};

	@media screen and (max-width: 1180px) {
		padding-top: calc(${(props) => props.theme.heights.headerMobile} + 5rem);
	}
`;

export const AuthContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.space2xl};
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	width: 100%;
	margin: 0 auto;
	padding: 0 ${(props) => props.theme.scale.contentPaddingX};
	box-sizing: border-box;
`;

export const AuthPageHeader = styled.header`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.space2xs};
`;

export const AuthEyebrow = styled.span`
	font-size: ${(props) => props.theme.fontSize.sizeXs};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 1;
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.label};
	text-transform: uppercase;
	color: ${(props) => props.theme.ui.interactive.primary};
`;

export const AuthTitle = styled.h1`
	margin: 0;
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
	line-height: 1.25;
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.tight};
	color: ${(props) => props.theme.ui.text.primary};
`;

export const AuthSubtitle = styled.p`
	margin: 0;
	max-width: 52ch;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 1.55;
	color: ${(props) => props.theme.ui.text.secondary};
`;

/** 회원가입 StepContent와 동일한 폼 카드 */
export const AuthFormCard = styled.section`
	width: 100%;
	padding: ${(props) => props.theme.scale.space2xl};
	border: 1px solid ${(props) => props.theme.ui.border.default};
	border-radius: ${(props) => props.theme.effects.radiusLg};
	background: ${(props) => props.theme.ui.surface.page};
	box-shadow: ${(props) => props.theme.effects.shadowSm};

	@media screen and (max-width: 900px) {
		padding: ${(props) => props.theme.scale.spaceLg};
	}
`;

export const AuthFieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.spaceXl};
	width: 100%;
`;

export const AuthFormActions = styled(FormActions)``;

export const AuthMenuBox = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: ${(props) => props.theme.scale.spaceSm};
	padding-top: ${(props) => props.theme.scale.spaceMd};
	border-top: 1px solid ${(props) => props.theme.ui.border.default};
`;
